export default __webpack_public_path__ + "static/media/photo-content-decor-2.bb3ec379.svg";